module.exports = __webpack_public_path__ + "static/media/icon-2.22aff307.svg";